import { render, staticRenderFns } from "./QuizCompetition.vue?vue&type=template&id=35a0cfd0"
import script from "./QuizCompetition.vue?vue&type=script&lang=js"
export * from "./QuizCompetition.vue?vue&type=script&lang=js"
import style0 from "./QuizCompetition.vue?vue&type=style&index=0&id=35a0cfd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports